export const getSessionTimerTimestamp = state => state.sessionTimerTimestamp;